<div class="custom-tab-wrapper my-4">
  <div class="custom-tab-buttons">
    <button [ngClass]="{ active: selectedTab === 0 }" (click)="selectedTab = 0">
      Unprocessed
    </button>
    <button [ngClass]="{ active: selectedTab === 1 }" (click)="selectedTab = 1">
      Processed
    </button>
    <button [ngClass]="{ active: selectedTab === 2 }" (click)="selectedTab = 2">
      Unreferenced
    </button>
    <button [ngClass]="{ active: selectedTab === 3 }" (click)="selectedTab = 3">
      Duplicate by CIK
    </button>
  </div>

  <div class="custom-tab-content">
    <ng-container [ngSwitch]="selectedTab">
      <app-insider-unprocessed
        *ngSwitchCase="0"
        [isActive]="isActive && selectedTab === 0"
      ></app-insider-unprocessed>

      <app-insider-processed
        *ngSwitchCase="1"
        [isActive]="isActive && selectedTab === 1"
      ></app-insider-processed>

      <app-insider-unreferenced
        *ngSwitchCase="2"
        [isActive]="isActive && selectedTab === 2"
      ></app-insider-unreferenced>

      <app-insider-duplicate-by-cik
        *ngSwitchCase="3"
        [isActive]="isActive && selectedTab === 3"
      ></app-insider-duplicate-by-cik>
    </ng-container>
  </div>
</div>
